import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-310c9d62"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "expire" };
const _hoisted_2 = { class: "text-overflow-lines" };
const _hoisted_3 = { class: "button_box" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "btn-txt" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "btn-txt" };
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { useStore } from '@/store/store';
import { setTimezone } from '@/logics/utils';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        apiAccessTokens: null
    },
    emits: ["clickEdit", "clickExtend", "clickDelete"],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const { MYPAGE_API_MANAGEMENT, format } = useMessage();
        const onClickEdit = (id) => __awaiter(this, void 0, void 0, function* () { return emit('clickEdit', id); });
        const onClickExtend = (token) => __awaiter(this, void 0, void 0, function* () { return !!token.can_extend_token && emit('clickExtend', token.id); });
        const onClickDelete = (id, label) => __awaiter(this, void 0, void 0, function* () { return emit('clickDelete', { id, label }); });
        return (_ctx, _cache) => {
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.apiAccessTokens, (token) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: token.id,
                    class: "item"
                }, [
                    _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_1, [
                            _createElementVNode("span", null, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).TEXT_EXPIRATION_PERIOD)) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_unref(setTimezone)(String(_unref(store).state.userSettings.localTime), token.expired_at, 'YYYY-MM-DD HH:mm:ss')) + " ", 1),
                            (!!token.can_extend_token)
                                ? (_openBlock(), _createBlock(MaterialIcon, {
                                    key: 0,
                                    name: "refresh",
                                    class: "icon --link",
                                    style: { "margin-left": "5px" },
                                    onClick: _withModifiers(($event) => (onClickExtend(token)), ["prevent"])
                                }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("span", {
                                class: "label --danger",
                                style: { "margin-left": "5px" }
                            }, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).TEXT_EXPIRED)), 513), [
                                [_vShow, token.expired]
                            ])
                        ]),
                        _createElementVNode("p", _hoisted_2, _toDisplayString(token.label), 1)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        (!token.expired)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "act-btn",
                                style: { "margin-right": "10px" },
                                onClick: _withModifiers(($event) => (onClickEdit(token.id)), ["prevent"])
                            }, [
                                _createVNode(MaterialIcon, {
                                    name: "edit",
                                    class: "icon",
                                    style: { "margin-right": "5px" }
                                }),
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).BTN_EDIT_API)), 1)
                            ], 8, _hoisted_4))
                            : _createCommentVNode("", true),
                        _createElementVNode("button", {
                            class: "act-btn --delete",
                            onClick: _withModifiers(($event) => (onClickDelete(token.id, token.label)), ["prevent"])
                        }, [
                            _createVNode(MaterialIcon, {
                                name: "delete",
                                class: "icon",
                                style: { "margin-right": "5px" }
                            }),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).BTN_DELETE_API)), 1)
                        ], 8, _hoisted_6)
                    ])
                ]));
            }), 128));
        };
    }
});
